<!-- 登陆页面 -->
<template>
    <div class="login-wrap">
        <div class="login-cont">
            <div class="cont-header">
                <i class="header-ico el-icon-arrow-left" @click="goBack"></i>
            </div>
            <div class="cont-main">
                <!--密码，验证码切换 头部-->
                <div class="switch-bar">
                    <p>重置密码</p>
                </div>
                <!-- <div class="self-info">手机号{{loginForm.tel}}</div> -->
                <div class="self-info">手机号18562323215</div>

                <!-- 表单 -->
                <div class="form-box">
                    <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0px" class="login-form">
                        <el-form-item prop="code">
                            <label class="label-txt" for="">验证码</label>
                            <el-input type="txt" class="padding-right" placeholder="请输入验证码" maxlength="6"
                                v-model="loginForm.code" clearable>
                            </el-input>
                            <el-button v-show="codeSta" class="get-code-btn" @click="getCode()">获取验证码</el-button>
                            <el-button v-show="!codeSta" class="get-code-btn">{{ count }}s</el-button>
                        </el-form-item>
                        <el-form-item prop="pwd">
                            <label class="label-txt" for="">设置密码</label>
                            <el-input type="password" placeholder="至少6位数字和字母组合" v-model="loginForm.pwd" clearable
                                show-password>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="confirmpwd">
                            <label class="label-txt" for="">确认密码</label>
                            <el-input type="password" placeholder="至少6位数字和字母组合" v-model="loginForm.confirmpwd" clearable
                                show-password>
                            </el-input>
                        </el-form-item>
                        <div class="login-btn">
                            <el-button type="primary" @click="submitForm('loginForm')"
                                :disabled="!loginForm.code || !loginForm.confirmpwd || !loginForm.pwd">提交并登录
                            </el-button>
                        </div>
                    </el-form>
                </div>

            </div>
        </div>

        <!-- 手机号未注册 -->
        <el-dialog class="public-dialog" title="" :visible.sync="dialogVisible" width="80%" top=58%>
            <span>您的手机号暂未注册</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="toRegister">立即注册</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import loginApi from '@/resources/loginModule/login'
    import config from '@/config'

    export default {
        data: function () {
            // 验证密码
            let checkPwd = (rule, value, callback) => {
                let reg = /^[0-9A-Za-z]{6,16}$/
                // let reg = /^\d{6,16}$/
                if (!value) {
                    return callback(new Error("请输入密码"));
                } else if (!reg.test(value)) {
                    return callback(new Error("请输入正确的密码"));
                } else {
                    callback();
                }
            };
            // 验证手机号
            let checkTel = (rule, value, callback) => {
                let reg = /^1[34578]\d{9}$/;
                if (!value) {
                    return callback(new Error("请输入手机号"));
                } else if (!reg.test(value)) {
                    return callback(new Error("请输入正确的手机号"));
                } else {
                    callback();
                }
            };
            //验证确认密码
            let checkConfirmPwd = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.loginForm.pwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                codeSta: true, //获取验证码按钮状态
                count: "",
                timer: null,
                //表单数据
                loginForm: {
                    userName: "",
                    pwd: "",
                    tel: "",
                    code: "",
                    confirmpwd: ""
                },
                //校验
                rules: {
                    pwd: [{ required: true, validator: checkPwd, trigger: "blur" }],
                    tel: [{ required: true, validator: checkTel, trigger: "blur" }],
                    code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
                    confirmpwd: [{ required: true, validator: checkConfirmPwd, trigger: 'blur' }],
                },
                ischecked: false,
                dialogVisible: false
            };
        },
        computed: {},
        created() { },
        mounted() { },
        methods: {
            // 获取验证码
            getCode() {
                if (!this.loginForm.tel) {
                    this.$message.warning("请输入手机号");
                } else {
                    this.sendMobileCode();
                }
            },
            // 验证码倒计时
            codeCountdown() {
                const TIME_COUNT = 60;
                if (!this.timer) {
                    this.count = TIME_COUNT;
                    this.codeSta = false;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                            this.count--;
                        } else {
                            this.codeSta = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000);
                }
            },
            // 找回密码
            submitForm(formName) {
                var that = this;
                this.$refs[formName].validate(valid => {
                    if (valid) {

                        let para = {
                            mobile: that.loginForm.tel,
                            password: that.loginForm.pwd,
                            captcha: that.loginForm.code,
                        };

                        loginApi.forgetPassword(para).then((res) => {
                            if (res.returnCode === 200) {
                                that.$message.success("登录成功");
                                // that.$router.push({ path: "/app/login" });
                                console.log("that.loginForm:", that.loginForm)
                            }
                        })
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            //发送验证码
            sendMobileCode() {
                let that = this;
                let para = {
                    mobile: that.loginForm.tel,
                    operationFlag: 2   //1.注册 2.忘记密码 3.登录 4.绑定手机号
                };
                loginApi.sendMobileCode(para).then((res) => {
                    if (res.returnCode === 200) {
                        that.codeCountdown();
                    } else if (res.returnCode === 40015) {
                        that.dialogVisible = true
                    }

                });
            },
            goBack() {
                this.$router.back()
            },
            toLogin() {
                this.$router.push({ path: "/app/login" });
            },
            toRegister() {
                this.$router.push({ path: "/app/registe" });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
        }
    };
</script>

<style scoped>
    @import "../../../assets/css/login/loginapp.css";
</style>